import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Button, Divider } from '@material-ui/core';

// UTILITY
import { updateUrl } from '@/utility/common';
import { getExternalUrlParams } from '@/utility/analytics';

// COMPONENTS
import ReactHtml from '@/components/ReactHtml';

// STYLES
import { CardStyled } from './styles';

const PackageCard = props => {
  const {
    data,
    unique_id,
    viewChannelProps,
    isActive,
    handleVisitSite,
    partner,
    hideExternal,
  } = props;
  const [t] = useTranslation();
  const externalUrlParams = getExternalUrlParams({ unique_id });
  const isWowPartner = partner === 'wow';

  return (
    <CardStyled className={clsx('package-card', isActive && 'package-card--active')}>
      {isWowPartner && isActive && (
        <Typography className="label" variant="h6" align="center">
          {t('common.recommendedPackage')}
        </Typography>
      )}
      <Typography className="title" variant="h3">
        {data.service_name}
      </Typography>
      <div className="package-card__price">
        <span className="price">${data.cost}</span>
        <span className="period">/{t('common.month')}</span>
      </div>
      <div className="package-card__divider">
        <Divider />
      </div>
      <div className="package-card__about">
        <ReactHtml className="markdown">{data.short_description?.trim()}</ReactHtml>
      </div>
      <Grid container spacing={2}>
        {!hideExternal && (
          <Grid item xs={12}>
            <Button
              component="a"
              href={updateUrl(data.url, externalUrlParams)}
              onClick={handleVisitSite}
              target="_blank"
              color="primary"
              size="medium"
              fullWidth
            >
              {t('buttons.visitSite')}
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <Button color="default" size="medium" fullWidth {...viewChannelProps}>
            {t('buttons.viewChannels')}
          </Button>
        </Grid>
      </Grid>
    </CardStyled>
  );
};

PackageCard.defaultProps = {
  data: {},
  unique_id: '',
  viewChannelProps: {},
  isActive: false,
  handleVisitSite: () => {},
  hideExternal: false,
};

PackageCard.propTypes = {
  data: PropTypes.object,
  unique_id: PropTypes.string,
  viewChannelProps: PropTypes.object,
  isActive: PropTypes.bool,
  handleVisitSite: PropTypes.func,
  partner: PropTypes.string,
  hideExternal: PropTypes.bool,
};

export default React.memo(PackageCard);
